export default __webpack_public_path__ + "static/media/kohli.be4021ca.jpg";